import React from 'react';
import Modal from 'components/Modal';
import {
	MetadataSummary,
	MetadataSummaryLine,
	ModalBody,
	SummaryLabel,
	SummaryValue,
	ValueWrapper,
} from './EditClassificationThreshold.styles';
import { ApInput, ApLoaderDefault } from '@alixpartners/ui-components';
import { useClassificationThresholdContext } from 'contexts/APVendorDBContext/ClassificationThresholdProvider';
import { NotificationTypes } from 'components/Toast/constants';
import { useToastMessageContext } from 'contexts/ToastMessageContext/ToastMessageProvider';

const EditClassificationThreshold = ({ setIsModal }) => {
	const {
		thresholdValue,
		isThresholdSaving,
		setThresholdValue,
		onSaveThreshold,
	} = useClassificationThresholdContext();
	const { showToast } = useToastMessageContext();

	return (
		<Modal
			width="620px"
			zIndex="10000000"
			title="Edit Classification Threshold"
			cancelLabel="Cancel"
			submitLabel={'Save'}
			onClose={() => setIsModal(false)}
			onSubmit={
				thresholdValue === ''
					? null
					: () =>
							onSaveThreshold().then(isSaved => {
								isSaved && setIsModal(false);
							})
			}
		>
			<ModalBody>
				{isThresholdSaving ? (
					<ApLoaderDefault
						loaderText={() => (
							<p style={{ textAlign: 'center' }}>Saving, please wait!</p>
						)}
					/>
				) : (
					<MetadataSummary>
						<MetadataSummaryLine>
							<SummaryLabel>Threshold:</SummaryLabel>
							<SummaryValue>
								<ValueWrapper>
									<ApInput
										type="number"
										name="threshold_value"
										onChange={v => {
											if (isNaN(v) || v === '' || Math.sign(v) !== 1) {
												showToast(
													'Enter correct value.',
													NotificationTypes.warning,
													1000
												);
												setThresholdValue('');
											} else {
												setThresholdValue(v);
											}
										}}
										value={thresholdValue === null ? '' : thresholdValue}
										shouldStopPropagation
									/>
								</ValueWrapper>
							</SummaryValue>
						</MetadataSummaryLine>
					</MetadataSummary>
				)}
			</ModalBody>
		</Modal>
	);
};

export default EditClassificationThreshold;
